import React, { forwardRef } from 'react';
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { IconProps } from '@chakra-ui/icons';

interface Props extends Omit<IconProps, `css`> {
  as: React.ElementType;
}

export const Icon = forwardRef<SVGSVGElement, Props>(
  ({ ...props }, ref): JSX.Element => {
    return <ChakraIcon ref={ref} {...props} />;
  }
);
export type { Props as IconProps };
